import { Autoplay, EffectFade, Navigation, Pagination, Swiper } from 'swiper';

import { $Elements, BrowserEvents } from './constants';

Swiper.use([Autoplay, EffectFade, Navigation, Pagination]);

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Masonry ----------

		$('.content-section .section-masonry').each(function() {
			const self = $(this);

			self.isotope({
				masonry: {
					percentPosition: true
				},
				itemSelector: ".single-column"
			})
		});
	});

}(jQuery));
